<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室院系汇总</h3>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="name" label="院系">
        </custom-table-column>
        <custom-table-column prop="major_count" label="专业数">
        </custom-table-column>
        <custom-table-column prop="count" :label="`${$store.state.themeTitle}室数`">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click="handlePath('/trainRoomByStructure/detail', { structure_ids: scope.row.structure_ids, structure_name: scope.row.name })"
              type="text" size="small">查看详情</el-button>
          </template>
        </custom-table-column>
      </custom-table>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'equipmentInto',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        device_name: '',
        training_room: '',
      },
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      eqs: [],
    };
  },
  components: {},
  created() {
    // this.getEqs();
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent');
  },
  methods: {
    handleLogChange(e) {
      this.ruleForm.scrap_name = this.$until.getLabelName(this.scraps, 'isid', 'ismc', e);
    },
    async getEqs() {
      let res = await this.getDataList('getDeviceIntoList');
      this.eqs = res.data.data;
    },
    handlePath(path, query) {
      this.$router.push({ path, query });
    },
    handleEqChange(val) {
      this.ruleForm.device_name = this.$until.getLabelName(this.eqs, 'device_no', 'device_name', val);
      this.ruleForm.device_num = this.$until.getLabelName(this.eqs, 'device_no', 'remainder_quantity', val);
      this.ruleForm.device_price = this.$until.getLabelName(this.eqs, 'device_no', 'device_price', val);
      console.log(this.ruleForm);
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceCount(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.buy_date) {
        let timee = params.buy_date.getTime() / 1000;
        params.buy_date = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createDeviceCount(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      // let params = this.$until.deleteNullPrototype(this.formInline);
      // params.page = this.$refs.pageChild.page;
      // params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getTrainXycollect();
      if (res.code == 0 && res.data) {
        this.tableData = res.data.filter(item => item.name != '联合办学点');
        // this.total = res.data.total;
      }
    },
    handleQuery() {
      // this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
